//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Header, Form, Button, ButtonStyle, MobileMenu } from '@cmp/common';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { ScreenSet, showScreenSet } from '@helpers/gigya';
import { StoreConfigContext } from '@helpers/storeConfigContext';
//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------
import { DoNotSellMyPersonalDataURL } from '@helpers/constants/colgate';
import { withTranslation } from 'react-i18next';
import { removeEmptyAddresses } from '@helpers/gigya';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
  }

  componentDidMount() {
    const {
      storeConfig: { language },
    } = this.context;

    showScreenSet(
      language,
      {
        ...ScreenSet.SignIn,
        events: {
          onAfterScreenLoad: (e) => {
            document
              .getElementById('login-container')
              .querySelectorAll('.gigya-input-text,.gigya-input-password')
              .forEach((nodeInput) => {
                nodeInput.addEventListener('keyup', (event) => {
                  window.interactiveLabel(event);
                });
              });
            removeEmptyAddresses(e);
          },
        },
      },
      'login-container'
    );
  }

  additionalComponent() {
    const { t } = this.props;
    return (
      <>
        <Link to="/signup" className={classNames(styles.Link, styles.Create)}>
          {t('login_CreateAccount')}
        </Link>
        <div className={styles.Footer}>
          <div className={styles.Row}>
            <Link to="/terms-of-service" target="_blank">{t('login_TermsOfService')}</Link>
            <span>&bull;</span>
            <Link to="/terms-and-conditions" target="_blank">{t('login_PrivacyPolicy')}</Link>
          </div>
          <a
            rel="noopener noreferrer"
            href={DoNotSellMyPersonalDataURL}
            target="_blank"
          >
            {t('login_DoNotSellPersonalData')}
          </a>
          <br />
        </div>
      </>
    );
  }

  handleToggle() {
    this.setState((state) => ({ toggle: !state.toggle }));
  }

  render() {
    const { t } = this.props;
    const componentClasses = classNames(styles.SignIn);
    const { toggle } = this.state;
    const { handleToggle } = this;

    const centerStyle = toggle
      ? { justifyContent: 'left' }
      : { justifyContent: 'center' };

    return (
      <div className={componentClasses} style={centerStyle}>
        <Helmet>
          <title>{t('landing_LogIn')}</title>
        </Helmet>

        <Header toggle={toggle} onToggle={handleToggle} />
        {toggle ? (
          <div className={styles.ContentMobile}>
            <MobileMenu />
          </div>
        ) : (
          <div className={styles.Content}>
            <Form
              className={styles.Form}
              title={t('login_HillsVetEcommLogin')}
              subtitle={t('login_HillsVetEcommLoginSubtitle')}
              onSubmit={() => this.setState({ submitted: true })}
              additionalComponent={this.additionalComponent()}
              id="login-container"
            />
          </div>
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(SignIn);
SignIn.contextType = StoreConfigContext;
